import { ChangeEvent, useCallback, useMemo, useState } from 'react';
import { JobCountDetailResponse } from '@doda/api-client/aspida/@types';
import { findJobCount } from 'components/IndustryModal/logics/createIndustryDisplayData';
import { WelfareBenefitsListType } from 'types/kodawari';
import { HooksArgument } from 'components/SearchSideBar/types';
import { createInitialWelfareBenefitsList } from '../../logics/welfareBenefits/createInitialWelfareBenefitsList';

/**
 * 待遇・福利厚生に関するhooks
 * @param args
 * @returns 表示用配列と更新処理
 */
export const useWelfareBenefits = (args: HooksArgument) => {
  const [welfareBenefitsList, setWelfareBenefitsList] = useState<
    WelfareBenefitsListType[]
  >(createInitialWelfareBenefitsList(args));

  const selectedWelfareBenefitsList = useMemo(() => {
    return welfareBenefitsList
      .filter(({ isChecked }) => isChecked)
      .map(({ value }) => value);
  }, [welfareBenefitsList]);

  // チェック状態更新処理
  const updateIsCheckedWelfareBenefitsList = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const checkedList = welfareBenefitsList.map((item) => {
        if (item.value !== event.target.value) return item;

        return {
          ...item,
          isChecked: event.target.checked,
        };
      });

      setWelfareBenefitsList(checkedList);

      return checkedList
        .filter(({ isChecked }) => isChecked)
        .map(({ value }) => value);
    },
    [welfareBenefitsList]
  );

  // 求人件数更新処理
  const updateWelfareBenefitsListJobCount = useCallback(
    (requirementsJobCountList: JobCountDetailResponse[] | undefined) => {
      setWelfareBenefitsList((pre) =>
        pre.map((item) => ({
          ...item,
          jobCount: findJobCount(requirementsJobCountList, item.value),
        }))
      );
    },
    []
  );

  return {
    welfareBenefitsList,
    selectedWelfareBenefitsList,
    updateIsCheckedWelfareBenefitsList,
    updateWelfareBenefitsListJobCount,
  };
};
